interface IconProps {
  color: string;
}

export default function ArrowIcon({ color }: IconProps) {
  return (
    <svg viewBox="366.89 415.59 107.81 180.8">
      <path
        fill={color}
        d="M379.207 415.59c3.152 0 6.3 1.203 8.707 3.605l86.79 86.801-86.79 86.79c-4.809 4.808-12.605 4.812-17.418 0-4.808-4.81-4.808-12.61 0-17.415l69.379-69.375-69.379-69.383c-4.808-4.808-4.808-12.605 0-17.418a12.3 12.3 0 0 1 8.711-3.605m0 0"
      ></path>
    </svg>
  );
}
